<script>
import {mapActions} from 'vuex'

export default {
  name: 'Loading',
  methods: {
    ...mapActions('user', ['loginAs'])
  },
  created () {
    this.$vs.loading()
    this.error = false
    const email = this.$route.query.email
    const token = this.$route.query.token

    this.loginAs({
      email,
      token
    })
      .then(() => {
        this.$vs.loading.close()
        this.$router.push({name: 'Dashboard'})
      })
      .catch(() => {
        this.$vs.loading.close()
        this.$router.push({name: 'Login'})
      })
  }
}

</script>
